/**
 * Immutable semantic presentation for one Number value.
 */
export type NumberReadContent = {
  readonly kind: 'number';
  readonly text: string;
};

export const EMPTY_NUMBER_CONTENT: NumberReadContent = Object.freeze({
  kind: 'number',
  text: ''
});
